<template>
  <div>
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header pay-invoice-form__row--error">
      <div></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Payment Error</div>
      <div></div>
    </div>

    <div class="panel">
      <div class="css-grid pay-invoice-form__row">
        <div></div>
        <div class="pay-invoice__message pay-invoice__message--error">
          Transaction failed, please update payment information and try again. If problem persists, please contact your regional team for assistance.
        </div>
        <div></div>
      </div>
    </div>

    <div class="pay-invoice__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep">Edit Payment Info</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorMessageView',
    methods: {
      nextStep() {
        this.$store.dispatch('payInvoice/setProperty', { key: 'paymentSection', value: 'amount'});
        this.$store.dispatch('payInvoice/setProperty', { key: 'currentSection', value: 'billingInfo'});
      },
    },
  }
</script>
